import { render, staticRenderFns } from "./in-warehouse.vue?vue&type=template&id=2d357f1a&scoped=true&"
import script from "./in-warehouse.vue?vue&type=script&lang=ts&"
export * from "./in-warehouse.vue?vue&type=script&lang=ts&"
import style0 from "./in-warehouse.vue?vue&type=style&index=0&id=2d357f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d357f1a",
  null
  
)

export default component.exports